import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pillars } from '@/mocks/pillars';

export default function PillarArticles() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">
            {t('guides.badge')}
          </span>
          <h2 className="mt-3 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            {t('guides.title')}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {t('guides.subtitle')}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {pillars.map((pillar) => (
            <Link
              key={pillar.slug}
              to={`/guide/${pillar.slug}`}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-all hover:-translate-y-0.5 hover:shadow-md cursor-pointer"
            >
              <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-100">
                <img
                  src={pillar.image}
                  alt={t(`pillar.${pillar.slug}.title`)}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              <div className="flex flex-1 flex-col p-6">
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center rounded-md bg-primary-50 px-2 py-1 font-semibold text-primary-700">
                    {t('nav.shoppingGuide')}
                  </span>
                  <span>{pillar.readTime}</span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950">
                  {t(`pillar.${pillar.slug}.title`)}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {t(`pillar.${pillar.slug}.excerpt`)}
                </p>
                <span className="mt-4 flex items-center gap-1.5 text-sm font-semibold text-primary-700">
                  {t('pillar.readGuide')}
                  <span className="flex h-3.5 w-3.5 items-center justify-center transition-transform group-hover:translate-x-0.5">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}